import axios from "./axios";
import { environment } from "../global/environment";

const getMyApplications = () => {
    return axios.get(environment.myApplicationsUri)
}
export { getMyApplications }

